<template>
  <div class="product">
    <div class="header-box">
      <layoutHeader :default-bg="'rgba(0,0,0,0.3)'"/>
    </div>
    <div class="content">
      <div class="title">
        <img src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661418205193366906.png" alt="">
      </div>
      <div class="tab">
        <template v-for="(item, index) in tabData">
          <div class="item" :class="index === tabIndex ? 'active' : ''" @click="changeType(index)">{{ item.name }}</div>
        </template>
      </div>
      <div class="main ">
        <div class="main-container">

          <el-row :gutter="20">
            <template v-for="(item, index) in list">
              <el-col :xs="12" :sm="8" :md="8" :lg="6" :key="index">
                <div class="item" @mousemove="onMouseMove(index)" @mouseleave="onMouseLeave" @click="onShowItem(index)">
                  <img :src="item.coverPicture" alt="" class="cover" fit="cover">
                  <img src="@/assets/slices/icon_play.png" alt="" class="play" v-if="item.type === 1">
                  <template v-if="currentIndex === index">
                    <img src="@/assets/slices/icon_resource_download.png" alt="" class="download" @click.stop="download(item)">
                    <div class="info">
                      <div class="name">{{ item.name }}</div>
                      <div class="size">大小: {{ item.uploadSize }}</div>
                    </div>
                  </template>
                </div>
              </el-col>
            </template>
          </el-row>
          <pagination :totalPage="totalPage" @pageChange="onPageChange"></pagination>
        </div>
      </div>
    </div>
    <div class="alert" v-if="showIndex > -1">
      <div class="info">
        <div class="title">{{ list[showIndex].name }}</div>
        <div class="close" @click="closeAlert">
          <img src="@/assets/slices/icon_close.png" alt="">
        </div>
        <div class="header">
          <img src="@/assets/slices/icon_resource_download.png" alt="" class="download" @click="download(list[showIndex])">
        </div>
        <el-image :src="list[showIndex].uploadUrl" style="width: 100%; height: 100%"
                  class="cover" fit="cover" v-if="list[showIndex].type !== 1"></el-image>
        <video :src="list[showIndex].uploadUrl" style="width: 100%; height: 100%" class="cover" v-else controls></video>
        <div class="size">大小: {{ list[showIndex].uploadSize }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'
import pagination from '@/components/pagination'
import Model from '@/model/resource'
import Utils from "@/utils/util"

export default {
  components: {
    layoutHeader,
    pagination
  },
  name: 'layout',
  data() {
    return {
      showAlert: false,
      currentIndex: -1,
      showIndex: -1,
      tabIndex: 0,
      tabData: [
        {
          name: '全部',
          type: ''
        },
        {
          name: '图片',
          type: 0
        },
        {
          name: '视频',
          type: 1
        }
      ],
      list: [],
      page: 1,
      totalPage: 0
    }
  },
  created() {
    this.getList()
  },
  mounted() {
  },
  methods: {
    changeType(index) {
      this.tabIndex = index
      this.list = []
      this.page = 1
      this.totalPage = 0
      this.getList()
    },
    async getList() {
      const res = await Model.getImageOrVideo(this.tabData[this.tabIndex].type, this.page)
      this.totalPage = res.data.totalPage
      this.page++
      res.data.resourceDownloadResps.forEach(item => {
        item.uploadSize = Utils.formatterSize(item.uploadSize)
      })
      this.list = res.data.resourceDownloadResps
    },
    onMouseMove(index) {
      this.currentIndex = index
    },
    onMouseLeave() {
      this.currentIndex = -1
    },
    onShowItem(index) {
      this.showIndex = index
    },
    closeAlert() {
      this.showIndex = -1
    },
    download(item) {
      window.open(item.uploadUrl)
    },
    onPageChange(page) {
      this.page = page
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  background: #fff;

  .header-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }

  .content {
    >.title {
      img {
        width: 100%;
      }
    }
    .tab {
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
      background: rgba(255, 255, 255, 0.8);
      box-shadow: 0px 6px 12px 1px rgba(0, 0, 0, 0.08);
      justify-content: center;

      .item {
        margin-right: 142px;
        line-height: 40px;
        cursor: pointer;
      }

      .active {
        color: #EB6100;
        border-bottom: 2px solid #EB6100;
      }
    }

    .main {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 40px;

      .item {
        width: 100%;
        height: 452px;
        background: none;
        border-radius: 6px;
        margin: 10px;
        position: relative;
        cursor: pointer;

        .cover {
          width: 100%;
          height: 452px;
          border-radius: 6px;
          z-index: 1;
        }

        .play {
          width: 55px;
          height: 55px;
          position: absolute;
          left: 50%;
          top: 50%;
          z-index: 3;
          transform: translate(-50%, -50%);
        }

        .download {
          width: 47px;
          height: 44px;
          position: absolute;
          z-index: 3;
          top: 12px;
          left: 12px;
        }

        .info {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 38px;
          color: #fff;
          padding: 8px;
          box-sizing: border-box;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          z-index: 2;

          .size {
            padding-left: 8px;
          }

          .name {
            flex: 1;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }
        }
      }
    }
  }

  .alert {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 200;
    background: rgba(0, 0, 0, 0.6);

    .info {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //width: 50%;
      //height: 90%;
      //max-width: 500px;
      //max-height: 600px;
      border-radius: 10px;
      width: 714px;
      height: 952px;

      .title {
        height: 38px;
        color: #fff;
        padding: 8px;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
        z-index: 100;
        position: absolute;
        top: -38px;
        width: 100%;
      }

      .close {
        position: absolute;
        right: -55px;
        top: 0;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
          width: 35px;
          height: 35px;
        }
      }

      .header {
        height: 60px;
        background: rgba(255, 255, 255, 0.2);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        border-radius: 8px 8px 0 0;
        z-index: 100;
        padding-left: 13px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        img {
          width: 47px;
          height: 44px;
        }

        .download {
          cursor: pointer;
        }
      }

      .cover {
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 10px;
        height: 100%;
        width: 100%;
        z-index: 99;
      }

      .size {
        position: absolute;
        bottom: 12px;
        right: 10px;
        font-size: 16px;
        color: #fff;
        z-index: 100;
        border-radius: 0 0 10px 0;

      }
    }
  }
}
</style>
